import { Injectable } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import {AjaxBridgeProvider} from '../ajax-bridge/ajax-bridge';
import {StorageManagerProvider} from '../storage-manager/storage-manager';
import {SocketManagerProvider} from '../socket-manager/socket-manager';
import * as Enums from '../../bayadic-shared-models/enums/Enums';
import {Collection } from '../../bayadic-shared-models/collection/Collection';
import {ModalDescriptionPage} from "../../app/modal-description/modal-description";
import { Events } from '../../providers/events/events';
import { LoggerService } from '../../app/services/logger.service';

/*
  Generated class for the ProductManagerProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ProductManagerProvider {

  constructor(
      public ajaxBridge : AjaxBridgeProvider,
      public platform  : Platform, 
      public storageManager  : StorageManagerProvider, 
      public socketManager  : SocketManagerProvider,
      public events: Events,
      public modalCtrl : ModalController,
      public logger: LoggerService
  ) {
    this.logger.debug('Hello ProductManagerProvider Provider');
    this.platform.ready().then(()=>{
        this.askRescue();
    });
  }
  registerEvents(){
      this.events.subscribe(Enums.EVENTS_Locally.platformReady, ()=>{
          this.storageManager.get("version").then((version)=>{
                if(version != undefined) {
                    let currentVersion = <string>version;
                    this.ajaxBridge.rescue(currentVersion).then(result=>{
                        this.getReaction(result);
                      })
                }
            })
        });
      
  }
  getReaction(res){
      let result = JSON.parse(res);
      if(result['error']){
        switch(result['action']){
            case 'updateApp' :
                this.askUpdateApp(result);
            break;
            case 'updateWebservers':
                this.updateWebservers(result);
            break;
            case 'updateAjaxUrl':
                this.updateAjaxUrl(result);
            break;
            case 'updateAdsSetting':
                this.updateAdsSetting(result);
            break;
        }
      }
  }
  async askUpdateApp(result){
                let collection = new Collection([]);
          collection.setLang("fa");
          collection.titleFa = "Update APP";
          collection.descriptionFa = result['msg'];
         let announcement =  await this.modalCtrl.create({
         component: ModalDescriptionPage,
             componentProps: { 'collection': collection }
         });
         announcement.present();
  }
  updateWebservers(result){
      this.storageManager.set("webserver",result["webserver"]);
      this.storageManager.set("version",result['version']);
      this.socketManager.websocket_server = result["webserver"];
//      this.socketManager.disconnect();
//      this.socketManager.connect();
  }
  updateAjaxUrl(result){
            this.storageManager.set("ajaxUrl",result["ajaxUrl"]);
            this.storageManager.set("version",result['version']);
            this.ajaxBridge.ajaxControllerServerUrl = result["ajaxUrl"];
  }
  updateAdsSetting(result){
            this.storageManager.set("adsTimePeriod",result["adsTimePeriod"]);
            this.storageManager.set("canShownAdsNumber",result["canShownAdsNumber"]);
            this.storageManager.set("version",result['version']);
  }
  askRescue(){
          this.storageManager.get("version").then((version)=>{
                if(version != undefined) {
                    let currentVersion = <string>version;
                    
                    this.ajaxBridge.rescue(currentVersion).then(result=>{
                        this.getReaction(result);
                      })
                }
                else {
                    this.storageManager.set("version","0");
                }
            })
  }
}
